// @flow

/**
 * Test if given value is not a valid email
 * @param value
 * @returns {boolean} true is value is not a valid email, false if value is a valid email
 */
export const isNotValidEmail = (value: ?string): boolean => {
  return !value || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value);
};

/**
 * Test if given value is not a valid full name
 * @param value
 * @returns {boolean} true is value is not a valid full name, false if value is a valid full name
 */
export const isNotValidName = (value: ?string): boolean => {
  // return !value || value.trim().split(' ').length < 2;
  return !value || value.length < 3;
};

/**
 * Test if given value is not a valid password
 * @param value
 * @returns {boolean} true is value is not a valid password, false if value is a valid password
 */
export const isNotValidPassword = (value: ?string): boolean => {
  return !value || value.trim().length < 6;
};

/**
 * Test if given value is not a valid phone
 * @param value
 * @returns {boolean} true is value is not a valid phone, false if value is a valid phone
 */
export const isNotValidPhone = (value: ?string): boolean => {
  return !value || !/^[+]?[0-9]{10,}$/i.test(value);
};
